import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import { removeEmptyKeys } from 'common/utils';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';
import { AccountFilterModel } from 'modules/account/types';

// screen
import type { ReplaceAccountsListResponse, ReplaceUserData } from 'modules/account/types';

// type AccountsListResponse = typeof schemas.UserListingResult._type;
type AccountsListResponse = ReplaceAccountsListResponse;

// export type Account = typeof schemas.UserData._type;
export type Account = ReplaceUserData;

interface Queries extends Partial<Omit<AccountFilterModel, 'name'>> {
  offset: number;
  pageSize: number;
}

interface Props {
  queries: Queries;
}

/**
 * Dữ liệu hiển thị cho màn Danh sách tài khoản
 */
const useGetAccountsList = ({ queries }: Props) => {
  const service = useService();

  // Create a more reliable query key that includes all query parameters
  const queryKey = [
    KEYS_QUERY.account,
    queries.pageSize,
    queries.offset,
    queries.query,
    queries.orgType,
    queries.orgId,
    queries.title,
    queries.inactive,
    queries.sortAsc,
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      try {
        if (!service) return null;
        const res: AccountsListResponse = await service.UserManagementController_listUser({
          queries: {
            ...removeEmptyKeys(queries),
            offset: queries.offset || 0,
            pageSize: queries.pageSize || 20,
          },
        });
        return res;
      } catch (error) {
        console.error('error: ', error);
        handleException(error);
      }
    },
    staleTime: 0, // Ensure fresh data on every request
    gcTime: 0, // Don't cache results (was cacheTime in older versions)
  });
};

export default useGetAccountsList;
